<div class="flex justify-center px-6 py-10">
  <div class="max-w-xl w-full">

    <div *ngIf="platformsLoading()" class="flex items-center gap-2 text-sm text-gray-400 mb-6">
      <span class="w-4 h-4 border-2 border-gray-200 border-t-blue-500 rounded-full animate-spin"></span>
      Loading TikTok accounts…
    </div>

    <div *ngIf="!platformsLoading() && tiktokPlatforms().length === 0"
      class="flex flex-col gap-3 px-4 py-4 mb-6 bg-yellow-50 border border-yellow-200 rounded-xl">
      <p class="text-sm text-yellow-700">⚠️ No TikTok account connected for this company.</p>
      <button
        type="button"
        (click)="connectTikTok()"
        class="self-start flex items-center gap-2 px-4 py-2 bg-black hover:bg-gray-900 text-white text-sm font-semibold rounded-xl transition-colors">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.75a4.85 4.85 0 0 1-1.01-.06z"/>
        </svg>
        Connect TikTok
      </button>
    </div>

    <!-- Multiple accounts — show dropdown -->
    <div *ngIf="tiktokPlatforms().length > 1" class="mb-6">
      <label class="block text-sm font-semibold text-gray-700 mb-2">📱 TikTok Account</label>
      <select (change)="selectPlatform($event)"
        class="cursor-pointer w-full border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50
              text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors">
        <option value="">Select an account</option>
        <option *ngFor="let p of tiktokPlatforms()" [value]="p.id">
          {{ p.social_media_id }}
        </option>
      </select>
    </div>

    <!-- Single account — show as read-only pill -->
    <div *ngIf="tiktokPlatforms().length === 1" class="flex items-center gap-2 mb-6">
      <span class="text-xs font-medium text-gray-500">Connected account:</span>
      <span class="px-3 py-1 bg-gray-100 text-gray-700 text-xs font-medium rounded-full">
        {{ tiktokPlatforms()[0].social_media_id }}
      </span>

      <!-- Add this temporarily next to your existing connected account pill -->
      <button (click)="reconnectTikTok()"
        class="text-xs text-blue-500 underline ml-2">
        Reconnect here
      </button>
    </div>

    <div *ngIf="tiktokPlatforms().length > 0" class="flex justify-end mb-4">
      <button
          type="button"
          (click)="openAnalytics()"
          class="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-xl text-sm font-medium
                text-gray-600 bg-gray-50 hover:border-blue-400 hover:text-blue-600 shadow-sm transition-colors">
          <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M3 13h4v8H3zM10 9h4v12h-4zM17 5h4v16h-4z" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Analytics
      </button>
    </div>

    <!-- ── Post Type ──────────────────────────────────────────────────── -->
    <div class="mb-6">
      <label class="block text-sm font-semibold text-gray-700 mb-2">🎬 What are you posting?</label>
      <select
        (change)="selectPostType($event)"
        class="cursor-pointer w-full border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50
              text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors">
        <option value="">Select post type</option>
        <option *ngFor="let pt of postTypes" [value]="pt.id" [disabled]="pt.disabled">{{ pt.label }}</option>
      </select>
    </div>

    <ng-container *ngIf="selectedPostType()">
      <form [formGroup]="uploadForm" (ngSubmit)="onUpload()" novalidate>

        <div class="mb-6">
            <label class="block text-sm font-semibold text-gray-700 mb-2">📎 Upload file</label>

            <ng-container *ngIf="selectedPostType() === 'carousel'">

                <div *ngIf="selectedFiles().length > 0" class="mb-3 flex flex-col gap-2">
                    <div *ngFor="let f of selectedFiles(); let i = index"
                        class="flex items-center justify-between px-3 py-2 bg-gray-50 border border-gray-200 rounded-xl text-sm">
                        <img [src]="getObjectUrl(f)"
                          class="w-12 h-12 object-cover rounded-lg shrink-0 border border-gray-200"
                          [alt]="f.name" />
                        <span class="text-gray-700 truncate">{{ f.name }}</span>
                        <button type="button" (click)="removeCarouselFile(i)"
                            class="ml-3 text-gray-400 hover:text-red-500 transition-colors text-xs underline shrink-0">
                            Remove
                        </button>
                    </div>
                    <p class="text-xs text-gray-400">{{ selectedFiles().length }} image(s) selected · min 2 required</p>
                </div>

                <div
                    (dragover)="$event.preventDefault(); dragOver.set(true)"
                    (dragleave)="dragOver.set(false)"
                    (drop)="onDrop($event)"
                    (click)="fileInput.click()"
                    [ngClass]="{
                        'border-blue-400 bg-blue-50': dragOver(),
                        'border-gray-300 bg-gray-50 hover:border-blue-400 hover:bg-blue-50': !dragOver()
                    }"
                    class="border-2 border-dashed rounded-xl px-4 py-6 flex flex-col items-center gap-2
                            cursor-pointer text-center transition-colors">
                    <input #fileInput type="file" [accept]="acceptedFileTypes" multiple
                        (change)="onFileSelected($event)" class="hidden" />
                    <svg class="w-6 h-6 text-gray-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                        <path d="M12 4v16m8-8H4" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <p class="text-sm font-medium text-gray-700">
                        {{ selectedFiles().length === 0 ? 'Add images' : 'Add more images' }}
                    </p>
                    <p class="text-xs text-gray-400">JPG · WEBP · max 20 MB each · min 2 images</p>
                </div>
            </ng-container>

            <!-- Video: original single file drop zone -->
            <ng-container *ngIf="selectedPostType() === 'video'">
              <div
                  (dragover)="$event.preventDefault(); dragOver.set(true)"
                  (dragleave)="dragOver.set(false)"
                  (drop)="onDrop($event)"
                  (click)="fileInput.click()"
                  [ngClass]="{
                      'border-blue-400 bg-blue-50':  dragOver(),
                      'border-emerald-400 bg-emerald-50': selectedFile() && !dragOver(),
                      'border-gray-300 bg-gray-50 hover:border-blue-400 hover:bg-blue-50': !dragOver() && !selectedFile()
                  }"
                  class="border-2 border-dashed rounded-xl px-4 py-10 flex flex-col items-center gap-2
                          cursor-pointer text-center transition-colors">
                  <input #fileInput type="file" [accept]="acceptedFileTypes" (change)="onFileSelected($event)" class="hidden" />

                  <ng-container *ngIf="!selectedFile(); else fileSelected">
                      <svg class="w-8 h-8 text-gray-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                          <path d="M7 16a4 4 0 0 1-.88-7.903A5 5 0 1 1 15.9 6L16 6a5 5 0 0 1 1 9.9M15 13l-3-3m0 0l-3 3m3-3v12" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <p class="text-sm font-medium text-gray-700">
                          Drop your video here or <span class="text-blue-500 underline">browse</span>
                      </p>
                      <p class="text-xs text-gray-400">MP4 · MOV · max 100 MB</p>
                  </ng-container>

                  <ng-template #fileSelected>
                      <div class="w-full flex flex-col items-center gap-3">
                          <video
                              [src]="getVideoUrl()"
                              controls
                              class="w-full max-h-64 rounded-xl object-contain bg-black"
                              (click)="$event.stopPropagation()">
                          </video>
                          <div class="flex items-center gap-4 text-sm text-gray-500">
                              <span>{{ selectedFile()!.name }}</span>
                              <span>{{ formatFileSize(selectedFile()!.size) }}</span>
                          </div>
                          <button type="button" (click)="$event.stopPropagation(); clearFile()"
                              class="text-xs text-gray-400 hover:text-red-500 underline transition-colors">
                              Remove
                          </button>
                      </div>
                  </ng-template>
              </div>
            </ng-container>
        </div>

        <!-- Caption -->
        <div class="mb-6">
          <label class="block text-sm font-semibold text-gray-700 mb-2">✏️ Caption <span class="font-normal text-gray-400">(optional)</span></label>
          <input
            type="text"
            formControlName="caption"
            placeholder="Write a caption…"
            class="w-full border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50
                  text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors" />
        </div>

        <div *ngIf="selectedPostType() === 'carousel'" class="mb-6">
          <label class="block text-sm font-semibold text-gray-700 mb-2">
              📝 Description
              <span class="font-normal text-gray-400">(optional)</span>
          </label>
          <textarea
              formControlName="description"
              placeholder="Write a description…"
              rows="3"
              class="w-full border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50
                    text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                    text-sm shadow-sm transition-colors resize-none">
          </textarea>
        </div>

        <!-- Success banner -->
        <div *ngIf="uploadDone()"
          class="flex items-center gap-3 px-4 py-3 mb-5 bg-emerald-50 border border-emerald-200 rounded-xl text-sm">
          <svg class="w-4 h-4 text-emerald-500 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 12l2 2 4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="text-gray-600">
            Published! Publish ID:
            <code class="font-mono text-xs bg-black/5 px-1.5 py-0.5 rounded">{{ publishId() }}</code>
          </span>
        </div>

        <div class="flex items-center justify-between">

          <button
            type="submit"
             [disabled]="uploading() ||
              (selectedPostType() === 'video' && !selectedFile()) ||
              (selectedPostType() === 'carousel' && selectedFiles().length < 2) ||
              !platformId()"
            class="flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700
                  disabled:opacity-40 disabled:cursor-not-allowed text-white text-sm font-semibold
                  rounded-xl shadow-sm transition-colors">
            <ng-container *ngIf="!uploading()">
              <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 16v1a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1M12 12V3m0 0L8 7m4-4 4 4" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Post to TikTok
            </ng-container>
            <ng-container *ngIf="uploading()">
              <span class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
              Posting…
            </ng-container>
          </button>

        </div>

      </form>
    </ng-container>

  </div>

  <!-- ── Analytics Modal ───────────────────────────────────────────────── -->
  <div *ngIf="showAnalytics()"
      class="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50"
      (click)="closeAnalytics()">

      <div class="bg-white rounded-2xl w-full max-w-3xl max-h-[85vh] flex flex-col overflow-hidden shadow-2xl"
          (click)="$event.stopPropagation()">

          <div class="flex items-center justify-between px-6 py-4 border-b border-gray-100">
              <span class="text-sm font-semibold text-gray-900">📊 TikTok Analytics</span>
              <button (click)="closeAnalytics()" class="text-gray-400 hover:text-gray-700 transition-colors">
                  <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
              </button>
          </div>

          <div class="flex border-b border-gray-100 px-6">
              <button
                  (click)="analyticsTab.set('page'); loadPageAnalytics()"
                  [ngClass]="analyticsTab() === 'page' ? 'border-b-2 border-blue-500 text-blue-600 font-semibold' : 'text-gray-500 hover:text-gray-800'"
                  class="py-3 px-4 text-sm transition-colors -mb-px">
                  Page metrics
              </button>
              <button
                  (click)="analyticsTab.set('summary'); loadAccountSummary()"
                  [ngClass]="analyticsTab() === 'summary' ? 'border-b-2 border-blue-500 text-blue-600 font-semibold' : 'text-gray-500 hover:text-gray-800'"
                  class="py-3 px-4 text-sm transition-colors -mb-px">
                  Performance
              </button>
              <button
                  (click)="analyticsTab.set('video')"
                  [ngClass]="analyticsTab() === 'video' ? 'border-b-2 border-blue-500 text-blue-600 font-semibold' : 'text-gray-500 hover:text-gray-800'"
                  class="py-3 px-4 text-sm transition-colors -mb-px">
                  Video stats
              </button>
          </div>

          <div class="overflow-y-auto px-6 py-5 flex flex-col gap-5">

              <ng-container *ngIf="analyticsTab() === 'page'">
                  <div *ngIf="pageAnalyticsLoading()" class="flex items-center gap-2 text-sm text-gray-400">
                      <span class="w-4 h-4 border-2 border-gray-200 border-t-blue-500 rounded-full animate-spin"></span>
                      Loading…
                  </div>
                  <div *ngIf="pageMetrics()" class="grid grid-cols-4 gap-3">
                      <div class="bg-gray-50 border border-gray-200 rounded-xl p-4 flex flex-col gap-1.5">
                          <span class="text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Account</span>
                          <span class="text-sm font-medium text-gray-900 truncate">{{ pageMetrics()!.name }}</span>
                      </div>
                      <div class="bg-gray-50 border border-gray-200 rounded-xl p-4 flex flex-col gap-1.5">
                          <span class="text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Followers</span>
                          <span class="text-2xl font-semibold text-gray-900">{{ formatNumber(pageMetrics()!.followers) }}</span>
                      </div>
                      <div class="bg-gray-50 border border-gray-200 rounded-xl p-4 flex flex-col gap-1.5">
                          <span class="text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Total likes</span>
                          <span class="text-2xl font-semibold text-gray-900">{{ formatNumber(pageMetrics()!.likes) }}</span>
                      </div>
                      <div class="bg-gray-50 border border-gray-200 rounded-xl p-4 flex flex-col gap-1.5">
                          <span class="text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Total Videos</span>
                          <span class="text-2xl font-semibold text-gray-900">{{ formatNumber(pageMetrics()!.video_count) }}</span>
                      </div>
                  </div>
              </ng-container>

              <!-- ── Performance / Summary tab ── -->
              <ng-container *ngIf="analyticsTab() === 'summary'">
                  <div *ngIf="accountSummaryLoading()" class="flex items-center gap-2 text-sm text-gray-400">
                      <span class="w-4 h-4 border-2 border-gray-200 border-t-blue-500 rounded-full animate-spin"></span>
                      Loading performance data…
                  </div>

                  <div class="flex items-start gap-3 px-4 py-3 bg-blue-50 border border-blue-100 rounded-xl text-sm text-blue-700">
                      <svg class="w-4 h-4 shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <path d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <span>
                          Performance data is calculated from your last 20 public videos. <br>
                          Engagement rate = <strong>(likes + comments + shares) / views × 100</strong>.<br>
                          Private or draft videos will show 0 until published publicly.
                      </span>
                  </div>

                  <ng-container *ngIf="accountSummary()">

                      <!-- Summary stat cards -->
                      <div class="grid grid-cols-2 gap-3 sm:grid-cols-4">
                          <div class="bg-gray-50 border border-gray-200 rounded-xl p-4 flex flex-col gap-1.5">
                              <span class="text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Total Views</span>
                              <span class="text-2xl font-semibold text-gray-900">{{ formatNumber(accountSummary().total_views) }}</span>
                          </div>
                          <div class="bg-gray-50 border border-gray-200 rounded-xl p-4 flex flex-col gap-1.5">
                              <span class="text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Total Likes</span>
                              <span class="text-2xl font-semibold text-gray-900">{{ formatNumber(accountSummary().total_likes) }}</span>
                          </div>
                          <div class="bg-gray-50 border border-gray-200 rounded-xl p-4 flex flex-col gap-1.5">
                              <span class="text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Total Shares</span>
                              <span class="text-2xl font-semibold text-gray-900">{{ formatNumber(accountSummary().total_shares) }}</span>
                          </div>
                          <div class="bg-gray-50 border border-gray-200 rounded-xl p-4 flex flex-col gap-1.5">
                              <span class="text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Engagement Rate</span>
                              <span class="text-2xl font-semibold text-gray-900">{{ accountSummary().engagement_rate }}%</span>
                          </div>
                      </div>

                      <!-- Total comments + video count row -->
                      <div class="grid grid-cols-2 gap-3">
                          <div class="bg-gray-50 border border-gray-200 rounded-xl p-4 flex flex-col gap-1.5">
                              <span class="text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Total Comments</span>
                              <span class="text-2xl font-semibold text-gray-900">{{ formatNumber(accountSummary().total_comments) }}</span>
                          </div>
                          <div class="bg-gray-50 border border-gray-200 rounded-xl p-4 flex flex-col gap-1.5">
                              <span class="text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Videos Analysed</span>
                              <span class="text-2xl font-semibold text-gray-900">{{ accountSummary().video_count }}</span>
                          </div>
                      </div>

                      <!-- Top video -->
                      <div *ngIf="accountSummary().top_video"
                          class="bg-blue-50 border border-blue-200 rounded-xl p-4 flex flex-col gap-2">
                          <span class="text-[10px] font-semibold text-blue-400 uppercase tracking-widest">🏆 Top Video by Views</span>
                          <span class="text-sm font-medium text-gray-900">{{ accountSummary().top_video.title || '(no title)' }}</span>
                          <div class="flex gap-4 text-xs text-gray-500 flex-wrap">
                              <span>👁 {{ formatNumber(accountSummary().top_video.view_count) }} views</span>
                              <span>❤️ {{ formatNumber(accountSummary().top_video.like_count) }} likes</span>
                              <span>💬 {{ formatNumber(accountSummary().top_video.comment_count) }} comments</span>
                              <span>↗️ {{ formatNumber(accountSummary().top_video.share_count) }} shares</span>
                          </div>
                      </div>

                      <!-- All videos table -->
                      <div class="rounded-xl border border-gray-100 overflow-hidden">
                          <table class="w-full text-sm border-collapse">
                              <thead>
                                  <tr class="bg-gray-50 border-b border-gray-100">
                                      <th class="text-left px-4 py-3 text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Title</th>
                                      <th class="text-left px-4 py-3 text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Views</th>
                                      <th class="text-left px-4 py-3 text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Likes</th>
                                      <th class="text-left px-4 py-3 text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Comments</th>
                                      <th class="text-left px-4 py-3 text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Shares</th>
                                      <th class="text-left px-4 py-3 text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Duration</th>
                                      <th class="text-left px-4 py-3 text-[10px] font-semibold text-gray-400 uppercase tracking-widest">ER %</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr *ngFor="let v of accountSummary().videos"
                                      class="border-b border-gray-50 hover:bg-gray-50 transition-colors last:border-0">
                                      <td class="px-4 py-3 text-gray-700 max-w-[160px] truncate">{{ v.title || '—' }}</td>
                                      <td class="px-4 py-3 text-gray-700">{{ formatNumber(v.view_count) }}</td>
                                      <td class="px-4 py-3 text-gray-700">{{ formatNumber(v.like_count) }}</td>
                                      <td class="px-4 py-3 text-gray-700">{{ formatNumber(v.comment_count) }}</td>
                                      <td class="px-4 py-3 text-gray-700">{{ formatNumber(v.share_count) }}</td>
                                      <td class="px-4 py-3 text-gray-700">{{ formatDuration(v.duration) }}</td>
                                      <td class="px-4 py-3 text-gray-700">
                                          {{ v.view_count > 0 ? (((v.like_count + v.comment_count + v.share_count) / v.view_count) * 100).toFixed(2) : '0.00' }}%
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </div>

                  </ng-container>
              </ng-container>

              <!-- ── Video stats tab ── -->
              <ng-container *ngIf="analyticsTab() === 'video'">
                  <div>
                      <label class="block text-sm font-semibold text-gray-700 mb-2">
                          🎬 Video IDs
                          <span class="font-normal text-gray-400 ml-1">one per line or comma-separated · max 20</span>
                      </label>
                      <textarea
                          rows="4"
                          [value]="videoIdsInput()"
                          (input)="setVideoIdsInput($event)"
                          placeholder="7380123456789012345&#10;7380987654321098765"
                          class="w-full border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                                focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm
                                transition-colors resize-none font-mono">
                      </textarea>
                      <p class="text-xs text-gray-400 mt-1">{{ parsedVideoIds().length }} / 20 IDs detected</p>
                  </div>

                  <div>
                      <button
                          type="button"
                          (click)="loadVideoAnalytics()"
                          [disabled]="videoAnalyticsLoading() || parsedVideoIds().length === 0"
                          class="flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700
                                disabled:opacity-40 disabled:cursor-not-allowed text-white text-sm font-semibold
                                rounded-xl shadow-sm transition-colors">
                          <span *ngIf="videoAnalyticsLoading()" class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
                          {{ videoAnalyticsLoading() ? 'Loading…' : 'Fetch stats' }}
                      </button>
                  </div>

                  <div *ngIf="videoStats().length > 0" class="rounded-xl border border-gray-100 overflow-hidden">
                      <table class="w-full text-sm border-collapse">
                          <thead>
                              <tr class="bg-gray-50 border-b border-gray-100">
                                  <th class="text-left px-4 py-3 text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Video ID</th>
                                  <th class="text-left px-4 py-3 text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Title</th>
                                  <th class="text-left px-4 py-3 text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Views</th>
                                  <th class="text-left px-4 py-3 text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Likes</th>
                                  <th class="text-left px-4 py-3 text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Comments</th>
                                  <th class="text-left px-4 py-3 text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Shares</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr *ngFor="let v of videoStats()" class="border-b border-gray-50 hover:bg-gray-50 transition-colors last:border-0">
                                  <td class="px-4 py-3 font-mono text-xs text-gray-400">{{ v.id }}</td>
                                  <td class="px-4 py-3 text-gray-700">{{ v.title || '—' }}</td>
                                  <td class="px-4 py-3 text-gray-700">{{ formatNumber(v.view_count) }}</td>
                                  <td class="px-4 py-3 text-gray-700">{{ formatNumber(v.like_count) }}</td>
                                  <td class="px-4 py-3 text-gray-700">{{ formatNumber(v.comment_count) }}</td>
                                  <td class="px-4 py-3 text-gray-700">{{ formatNumber(v.share_count) }}</td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </ng-container>

          </div>
      </div>
  </div>
</div>
